var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"create-section d-flex flex-row justify-space-around flex-wrap h-100"},[_c('create-booking')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }